/*global angular*/
/*global _*/

angular.module('campaignLookupApp')

.filter('percentage', ['$filter', function ($filter) {
  return function (input, decimals) {
    return $filter('number')(input * 100, decimals) + '%';
  };
}])

.filter('reverse', function() {
  return function(items) {
    return items.slice().reverse();
  };
})

.filter('matchedCampaigns', function() {
  return function( campaigns ) {
      var ret = _.filter( campaigns, function( campaign ) {
    	  if ( campaign.campaignMatch ) return true;
    	  return false;
      });
      return ret;
  };
})

.filter('min_payout', function() {
	return function(camps,min) {
		var ret = _.filter( camps, function( camp ) {
			if ( camp.payout === "n/a" ) {
				// For campaigns with no payout, check if they are a well defined CPC campaign with a payout for click event.
				if ( camp.knownEvents ) {
					for ( var i = 0; i < camp.knownEvents.length; i++ ) {
						if ( camp.knownEvents[i].eventTypeCode === "CPC" && camp.knownEvents[i].eventType === "CLICK" &&  camp.knownEvents[i].eventSourceType === "FEED_WELL_DEFINED" && camp.knownEvents[i].grossCPA && camp.knownEvents[i].grossCPA > 0.0 ) {
							return true;
						}
					}
				}
				return false;
			}
			return camp.payout >= min;
		});
		return ret;
	};
})

.filter('has_country', function() {
	return function(camps,tags) {
		var ret = _.filter( camps, function( camp ) {
			if( !tags || tags.length === 0 ) return true;
			
			var tgs = _.map( tags, function( tag ) {
				return tag.text;
			});

			var sect = _.intersection( camp.countries.split(','), tgs );
			if( sect && sect.length > 0 ) {
				return true;
			} else {
				return false;
			}
		});

		return ret;
	};
})

.filter( 'secondsToHumanReadable', [ '$filter', function( $filter ) {
	return function( seconds ) {
		var DAY_IN_SECONDS = 60*60*24;
		var HOUR_IN_SECONDS = 60*60;
		var MINUTE_IN_SECONDS = 60;
				
		if ( seconds >= 5*DAY_IN_SECONDS ) {
			return ( Math.round( seconds / (DAY_IN_SECONDS) ) ) + "d";
		} else if ( seconds >= 1*DAY_IN_SECONDS ) {
			return ( Math.round( 10* ( seconds / (DAY_IN_SECONDS) ))/10 ) + "d";			
		} else if ( seconds >= HOUR_IN_SECONDS ) {
			return ( Math.round( 10* ( seconds / HOUR_IN_SECONDS ) )/10 ) + "h";
		} else if ( seconds >= MINUTE_IN_SECONDS ) {
			return ( Math.round( 10* ( seconds / MINUTE_IN_SECONDS ) )/10 ) + "m";
		} else {
			return ( Math.round( 10* (seconds) ) / 10 ) + "s";
		}		
	}
}])

.filter( 'iso8601ToString', [ '$filter', function( $filter ) {
	  return function( iso8601date, type ) {
		  var date = new Date( iso8601date );
		  if ( type === 'time') {
			  return $filter( 'date' )( date, 'h:mm a' );
		  }
		  return $filter( 'date' )( date, 'M/d/yy' );
	  };
} ] )

.filter( 'statusOnly', function() {
	  return function( status ) {
		  if ( status ) {
			  return status.split( ' ' )[0];
		  }
		  return status;
	  };
} )
;
